<div class="ops-completed-projects-stats">
  <label>{{ 'auth.completedProjectsStats.completedProjects' | translate }}</label>

  <div class="completed-count" *ngIf="isLoading">
    <div class="cssload-container">
      <div class="cssload-speeding-wheel"></div>
    </div>
  </div>
  <div class="completed-count" *ngIf="!isLoading">
    {{ completedProjectsCount }}
  </div>
</div>
